module.exports = __webpack_public_path__ + "assets/img/ptp06.676cc996.png";